import { useTheme } from "@/theme/ThemeProvider";
import { Text, View, type ViewStyle } from "react-native";

/**
 * Eleganter Leerzustand – ruhig, ohne große Kartenoptik.
 */
export function EmptyState({
  title,
  hint,
  style,
}: {
  title: string;
  hint?: string;
  style?: ViewStyle;
}) {
  const { theme } = useTheme();
  return (
    <View
      style={[
        {
          paddingVertical: theme.space.md,
          gap: 4,
        },
        style,
      ]}
    >
      <Text
        style={{
          color: theme.color.textSecondary,
          fontSize: theme.fontSize.small,
          fontWeight: "500",
        }}
      >
        {title}
      </Text>
      {hint ? (
        <Text
          style={{
            color: theme.color.muted,
            fontSize: theme.fontSize.tiny,
            lineHeight: 16,
          }}
        >
          {hint}
        </Text>
      ) : null}
    </View>
  );
}
